/**
 * AbilityHacker.js
 * Implements the Hacker enemy ability
 */

import { Game, GameTimer } from "pixi_core";

import { Ability } from "./Ability";
import { Common } from "../Common";
import { Bubble } from "../Bubble";

import { shuffle, BubbleColor, ENEMY_ABILITY_PARTICLE_TRAVEL_TIME } from "../../Constants";

export class AbilityHacker extends Ability {
    /**
     * @public
     * @param {Number} nbBubbles
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(nbBubbles, startPos, callback) {
        super();

        /** @private @type {{bubble: Bubble, color: BubbleColor}[]} */
        this._changes = [];

        let coloredBubbles = Common.grid.getColoredBubbles(false);
        if (coloredBubbles.length > 0) {
            coloredBubbles = shuffle(coloredBubbles);

            for (let i = 0; i < coloredBubbles.length; ++i) {
                if (i < nbBubbles) {
                    const bubble = coloredBubbles[i];

                    let newColor = Math.floor(Math.random() * BubbleColor.eSPECIAL);
                    while (newColor === bubble.color) {
                        newColor = Math.floor(Math.random() * BubbleColor.eSPECIAL);
                    }

                    this._changes.push({
                        bubble: bubble,
                        color: newColor
                    });

                    if (startPos) {
                        Common.particles.createEnemyAbilityParticle(startPos.x, startPos.y, bubble.x, bubble.y, null);
                    }
                } else {
                    break;
                }
            }
        }

        const delay = startPos && this._changes.length > 0 ? ENEMY_ABILITY_PARTICLE_TRAVEL_TIME : 0;

        /** @private @type {GameTimer} */
        this._timerParticlesDelay = Game.windows.getCurrentWindow().createTimer(delay);
        this._timerParticlesDelay.onComplete = () => {
            if (this._changes) {
                for (const change of this._changes) {
                    change.bubble.changeColor({ color: change.color, special: change.bubble.specialType });
                }
            }

            if (callback) {
                callback();
            }
        };
    }

    /**
     * @public
     */
    destroy() {
        if (this._timerParticlesDelay) {
            this._timerParticlesDelay.destroy();
            this._timerParticlesDelay = null;
        }

        this._changes = null;
    }
}
